(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hp-judgeme-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hp-judgeme-badge')) {
    class HpJudgeMeBadge extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleCardReviewNavigation, true);
        this.addEventListener('keydown', this.handleCardReviewNavigation, true);
        this.addEventListener('auxclick', this.handleCardReviewNavigation, true);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleCardReviewNavigation, true);
        this.removeEventListener('keydown', this.handleCardReviewNavigation, true);
        this.removeEventListener('auxclick', this.handleCardReviewNavigation, true);
      }
      handleCardReviewNavigation = (event) => {
        if (!this.closest('product-card, .hp-pro-product-card')) return;
        if (!(event.target instanceof Element)) return;
        if (!event.target.closest('.jdgm-preview-badge')) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (event.type === 'auxclick' && event.button !== 1) return;
        if (event.type === 'click' && event.button !== 0) return;
        const productUrl = this.dataset.productUrl;
        if (!productUrl) return;
        let destination;
        try {
          destination = new URL(productUrl, window.location.origin);
        } catch {
          return;
        }
        if (destination.origin !== window.location.origin) return;
        destination.hash = 'judgeme_product_reviews';
        event.preventDefault();
        event.stopPropagation();
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.type === 'auxclick') {
          window.open(destination.href, '_blank', 'noopener');
        } else {
          window.location.assign(destination.href);
        }
      };
    }
    customElements.define('hp-judgeme-badge', HpJudgeMeBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
